/**
 * Deployed dev environment (main branch). Not for local `ng serve`.
 * Substituted via angular.json `development` configuration fileReplacements.
 */
export const environment = {
  production: false,

  treesloAppUrl: "https://dev.treeslo.com",
  /** Dev landing: S3 + CloudFront in the dev account (treeslo-infra envs/dev_landing). */
  landingSiteUrl: "https://dev-landing.treeslo.com",
  marketingReturnUrl: "https://dev-landing.treeslo.com/",

  treesloAppPaths: {
    dashboard: "/dashboard",
    knowledgeBase: "/help/knowledge-base",
    faqs: "/help/faqs",
    privacyPolicy: "/legal/privacy-policy",
    eula: "/legal/eula",
  },
} as const;

export type LandingEnvironment = typeof environment;
